import { render, staticRenderFns } from "./BtnExportarRendimentos.vue?vue&type=template&id=8e0637d2"
import script from "./BtnExportarRendimentos.vue?vue&type=script&lang=js"
export * from "./BtnExportarRendimentos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports